import {
  FETCH_HOSPITAL_AFFILIATIONS_START,
  FETCH_HOSPITAL_AFFILIATIONS_SUCCESS,
  FETCH_HOSPITAL_AFFILIATIONS_FAILURE,
  SET_HOSPITAL_AFFILIATIONS_QUERY_PARAMS,
} from '../constants/hospitalAffiliationsActionsTypes';

const initialState = {
  list: [],
  params: {
    per_page: 10,
    page: 1,
    sort: 'created_at,desc',
    scope: ['withHospitalSystem', 'withTenant'],
    search: '',
  },
  total: 0,
  isStarted: false,
  isLoad: false,
  isError: false,
  msg: null,
};

function hospitalAffiliations(state = initialState, action) {
  switch (action.type) {
    case FETCH_HOSPITAL_AFFILIATIONS_START:
      return {
        ...state,
        isStarted: true,
        isLoad: false,
        isError: false,
        msg: null,
      };
    case FETCH_HOSPITAL_AFFILIATIONS_SUCCESS:
      return {
        ...state,
        list: action.payload.hospitalAffiliations,
        total: action.payload.total,
        isStarted: false,
        isLoad: true,
        isError: false,
      };
    case FETCH_HOSPITAL_AFFILIATIONS_FAILURE:
      return {
        ...state,
        list: [],
        isStarted: false,
        isLoad: true,
        isError: true,
        msg: action.payload,
      };
    case SET_HOSPITAL_AFFILIATIONS_QUERY_PARAMS:
      return {
        ...state,
        params: {
          ...state.params,
          ...action.params,
        },
      };
    default:
      return state;
  }
}

export default hospitalAffiliations;
